/**
 * ResultsHeader 컴포넌트
 *
 * 검색 결과 요약 헤더
 */

import { Sparkles, RotateCcw } from 'lucide-react'
import { useI18n, interpolate } from '../i18n'

interface ResultsHeaderProps {
  /** 결과 개수 */
  resultCount: number
  /** 처리 시간 (ms) - 허밍 검색에서만 사용 */
  processingTime?: number | null
  /** 다시 시도 핸들러 */
  onRetry: () => void
}

export function ResultsHeader({ resultCount, processingTime, onRetry }: ResultsHeaderProps) {
  const { t } = useI18n()

  return (
    <div className="bg-dark-700 rounded-xl shadow-md p-4 border border-dark-500/50">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Sparkles className="w-6 h-6 text-accent-500" />
          <div>
            <h2 className="text-lg font-semibold text-text-primary">
              {resultCount > 0
                ? interpolate(t('resultsFound'), { count: resultCount })
                : t('noResults')
              }
            </h2>
            {processingTime && (
              <p className="text-sm text-text-muted">
                {interpolate(t('processingTime'), { ms: processingTime })}
              </p>
            )}
          </div>
        </div>

        <button
          onClick={onRetry}
          className="flex items-center gap-2 px-4 py-2 bg-dark-600 hover:bg-dark-500 text-text-secondary rounded-lg transition-colors"
        >
          <RotateCcw className="w-4 h-4" />
          {t('retry')}
        </button>
      </div>
    </div>
  )
}
